import { render, staticRenderFns } from "./KvmServerResources.vue?vue&type=template&id=1159ade9&scoped=true&"
import script from "./KvmServerResources.vue?vue&type=script&lang=js&"
export * from "./KvmServerResources.vue?vue&type=script&lang=js&"
import style0 from "./KvmServerResources.vue?vue&type=style&index=0&id=1159ade9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1159ade9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1159ade9')) {
      api.createRecord('1159ade9', component.options)
    } else {
      api.reload('1159ade9', component.options)
    }
    module.hot.accept("./KvmServerResources.vue?vue&type=template&id=1159ade9&scoped=true&", function () {
      api.rerender('1159ade9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/services/hosting/kvm/KvmServerResources.vue"
export default component.exports